// 门诊方向主题色，照抄demo(hlky/user-end/js/app.js)里的 DIR_COLORS 配色表。
// demo是按方向的固定id(d1~d4)查表，咱们真实的方向id是雪花算法生成的长数字，
// 没法照抄这种查表方式，改成"按方向在列表里的顺序，循环使用这4种颜色"，效果等价，
// 方向数量不多的情况下不会有违和感。

const DIR_COLOR_LIST = [
  { solid: "#0E7490", tint: "#ECFEFF" },
  { solid: "#4F46E5", tint: "#EEF2FF" },
  { solid: "#B45309", tint: "#FFFBEB" },
  { solid: "#BE185D", tint: "#FFF1F2" },
];

// index: 该方向在列表里的下标(第几个)，不是方向id
export function dirColorByIndex(index) {
  return DIR_COLOR_LIST[index % DIR_COLOR_LIST.length];
}

// 备用：如果拿不到下标、只有方向id的场景(比如直接进方向详情页，没有完整列表上下文)，
// 用id字符串做一个简单稳定的哈希，保证同一个方向每次算出来的颜色都一样，不会来回跳变
export function dirColorById(id) {
  if (!id) return DIR_COLOR_LIST[0];
  let str = String(id);
  let sum = 0;
  for (let i = 0; i < str.length; i++) {
    sum += str.charCodeAt(i);
  }
  return DIR_COLOR_LIST[sum % DIR_COLOR_LIST.length];
}
